// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— New medical machine fields (Stitch: New medical machine) ——— */
.machine-form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: none !important;
  min-width: 0;
  align-self: stretch;
}

.machine-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 20px;
  width: 100%;
  max-width: none;
  min-width: 0;
}

.machine-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.machine-form__field--full,
.machine-form__callout {
  grid-column: 1 / -1;
}

.machine-form__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.machine-form__req {
  color: #EF4444;
}

.machine-form__callout {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
  color: #64748B;
  font-size: 12px;
  line-height: 1.4;
}

.machine-form__callout .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
}

.machine-form__assignments {
  box-sizing: border-box;
  min-height: 112px;
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.machine-form__assignments-empty {
  margin: 0;
  font-size: 12px;
  color: #94A3B8;
  line-height: 1.5;
}

.machine-form__assignment {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
}

.machine-form__assignment-name {
  padding-top: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  min-width: 0;
}

.machine-form__assignment-date {
  width: 180px;
  flex-shrink: 0;
}

.machine-form__placeholder {
  min-height: 240px;
}

.machine-form .ant-form-item {
  margin-bottom: 0 !important;
  line-height: normal !important;
  font-size: 12px !important;
}

.machine-form .ant-form-item-label {
  display: none;
  padding: 0 !important;
}

.machine-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.machine-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.machine-form .ant-form-item-feedback-icon {
  display: none !important;
}

.machine-form .ant-select,
.machine-form .ant-picker,
.machine-form .ant-input-affix-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.machine-form .ant-input-affix-wrapper,
.machine-form .ant-input-affix-wrapper-lg,
.machine-form .ant-picker,
.machine-form .ant-select-single .ant-select-selector {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  font-size: 12px !important;
  color: #0F172A !important;
  background: #fff !important;
  box-shadow: none !important;
}

.machine-form .ant-select-multiple .ant-select-selector {
  box-sizing: border-box !important;
  min-height: 36px !important;
  height: auto !important;
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  font-size: 12px !important;
  background: #fff !important;
  box-shadow: none !important;
  padding: 2px 8px !important;
}

.machine-form .ant-input-affix-wrapper,
.machine-form .ant-input-affix-wrapper-lg {
  padding: 0 12px !important;
  display: inline-flex !important;
  align-items: center !important;
}

.machine-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  border: 1px solid #E2E8F0 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
  background: #fff !important;
  box-shadow: none !important;
}

.machine-form .ant-input-affix-wrapper input.ant-input,
.machine-form .ant-input-affix-wrapper-lg input.ant-input {
  box-sizing: border-box !important;
  height: 100% !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
}

.machine-form input.ant-input::placeholder,
.machine-form .ant-picker-input > input::placeholder,
.machine-form .ant-select-selection-placeholder {
  color: #94A3B8 !important;
  opacity: 1 !important;
}

.machine-form .ant-picker {
  width: 100%;
  padding: 0 11px !important;
  display: flex !important;
  align-items: center !important;
}

.machine-form .ant-picker-input > input {
  font-size: 12px !important;
  line-height: 1.5 !important;
  height: auto !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.machine-form .ant-select-single .ant-select-selector {
  display: flex !important;
  align-items: center;
  padding-inline: 11px !important;
}

.machine-form .ant-select-single .ant-select-selection-item,
.machine-form .ant-select-single .ant-select-selection-placeholder {
  line-height: 34px !important;
  font-size: 12px !important;
}

.machine-form .ant-select-multiple .ant-select-selection-item {
  height: 22px;
  line-height: 20px !important;
  margin-top: 2px;
  border: none;
  border-radius: 999px;
  background: #E0F2FE;
  color: #0369A1;
  font-size: 12px;
}

.machine-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,
.machine-form .ant-input-affix-wrapper:hover,
.machine-form .ant-picker:hover,
.machine-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #94A3B8 !important;
}

.machine-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,
.machine-form .ant-input-affix-wrapper-focused,
.machine-form .ant-input-affix-wrapper:focus-within,
.machine-form .ant-picker-focused,
.machine-form .ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

@media (max-width: 720px) {
  .machine-form__grid {
    grid-template-columns: 1fr;
  }

  .machine-form__assignment {
    flex-direction: column;
    align-items: stretch;
  }

  .machine-form__assignment-date {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/medicalMachines/style.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;EAIE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;;EAKE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ——— New medical machine fields (Stitch: New medical machine) ——— */\n.machine-form {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0;\n  align-self: stretch;\n}\n\n.machine-form__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 24px;\n  row-gap: 20px;\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n}\n\n.machine-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.machine-form__field--full,\n.machine-form__callout {\n  grid-column: 1 / -1;\n}\n\n.machine-form__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.machine-form__req {\n  color: #EF4444;\n}\n\n.machine-form__callout {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.machine-form__callout .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.machine-form__assignments {\n  box-sizing: border-box;\n  min-height: 112px;\n  padding: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.machine-form__assignments-empty {\n  margin: 0;\n  font-size: 12px;\n  color: #94A3B8;\n  line-height: 1.5;\n}\n\n.machine-form__assignment {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  min-width: 0;\n}\n\n.machine-form__assignment-name {\n  padding-top: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  min-width: 0;\n}\n\n.machine-form__assignment-date {\n  width: 180px;\n  flex-shrink: 0;\n}\n\n.machine-form__placeholder {\n  min-height: 240px;\n}\n\n.machine-form .ant-form-item {\n  margin-bottom: 0 !important;\n  line-height: normal !important;\n  font-size: 12px !important;\n}\n\n.machine-form .ant-form-item-label {\n  display: none;\n  padding: 0 !important;\n}\n\n.machine-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.machine-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.machine-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.machine-form .ant-select,\n.machine-form .ant-picker,\n.machine-form .ant-input-affix-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n.machine-form .ant-input-affix-wrapper,\n.machine-form .ant-input-affix-wrapper-lg,\n.machine-form .ant-picker,\n.machine-form .ant-select-single .ant-select-selector {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  font-size: 12px !important;\n  color: #0F172A !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.machine-form .ant-select-multiple .ant-select-selector {\n  box-sizing: border-box !important;\n  min-height: 36px !important;\n  height: auto !important;\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  font-size: 12px !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  padding: 2px 8px !important;\n}\n\n.machine-form .ant-input-affix-wrapper,\n.machine-form .ant-input-affix-wrapper-lg {\n  padding: 0 12px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n.machine-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 6px 12px !important;\n  border-radius: 8px !important;\n  border: 1px solid #E2E8F0 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.machine-form .ant-input-affix-wrapper input.ant-input,\n.machine-form .ant-input-affix-wrapper-lg input.ant-input {\n  box-sizing: border-box !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 12px !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n}\n\n.machine-form input.ant-input::placeholder,\n.machine-form .ant-picker-input > input::placeholder,\n.machine-form .ant-select-selection-placeholder {\n  color: #94A3B8 !important;\n  opacity: 1 !important;\n}\n\n.machine-form .ant-picker {\n  width: 100%;\n  padding: 0 11px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.machine-form .ant-picker-input > input {\n  font-size: 12px !important;\n  line-height: 1.5 !important;\n  height: auto !important;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.machine-form .ant-select-single .ant-select-selector {\n  display: flex !important;\n  align-items: center;\n  padding-inline: 11px !important;\n}\n\n.machine-form .ant-select-single .ant-select-selection-item,\n.machine-form .ant-select-single .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  font-size: 12px !important;\n}\n\n.machine-form .ant-select-multiple .ant-select-selection-item {\n  height: 22px;\n  line-height: 20px !important;\n  margin-top: 2px;\n  border: none;\n  border-radius: 999px;\n  background: #E0F2FE;\n  color: #0369A1;\n  font-size: 12px;\n}\n\n.machine-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,\n.machine-form .ant-input-affix-wrapper:hover,\n.machine-form .ant-picker:hover,\n.machine-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: #94A3B8 !important;\n}\n\n.machine-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,\n.machine-form .ant-input-affix-wrapper-focused,\n.machine-form .ant-input-affix-wrapper:focus-within,\n.machine-form .ant-picker-focused,\n.machine-form .ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n@media (max-width: 720px) {\n  .machine-form__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .machine-form__assignment {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .machine-form__assignment-date {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
